import ScriptBreakdownApp from './ScriptBreakdownApp'

function App() {
  return <ScriptBreakdownApp />
}

export default App
